export enum ConfirmationEnum {
  valid = 'valid',
  denied = 'denied',
  canceled = 'canceled'
}
